<template>
  <el-dialog
    :title="formData.id ? 'Зардал засварлах' : 'Шинэ зардал үүсгэх'"
    :visible.sync="dialogVisible"
    width="60%"
    @close="handleClose"
  >
    <div>
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="150px">
        <el-row v-if="!isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Огноо" prop="date">
              <el-date-picker
                v-model="formData.date"
                type="date"
                placeholder="Огноо сонгоно уу"
                style="width: 100%"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Огноо" prop="date">
              <el-date-picker
                v-model="formData.date"
                type="date"
                placeholder="Огноо сонгоно уу"
                style="width: 100%"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Шилжүүлэх салбар" prop="transfer_from_branch_id">
              <el-select v-model="formData.transfer_from_branch_id" placeholder="Шилжүүлэх салбар сонгоно уу" style="width: 100%">
                <el-option
                  v-for="branch in branches"
                  :key="branch.id"
                  :label="branch.branch_name"
                  :value="branch.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Хүлээн авах салбар" prop="transfer_to_branch_id">
              <el-select v-model="formData.transfer_to_branch_id" placeholder="Хүлээн авах салбар сонгоно уу" style="width: 100%">
                <el-option
                  v-for="branch in branches"
                  :key="branch.id"
                  :label="branch.branch_name"
                  :value="branch.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Дүн" prop="amount">
              <el-input-number
                v-model="formData.amount"
                :min="0"
                :precision="2"
                placeholder="Дүнг оруулна уу"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Дансны дугаар" prop="account_number">
              <el-input v-model="formData.account_number" placeholder="Дансны дугаар оруулна уу" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Дүн" prop="amount">
              <el-input-number
                v-model="formData.amount"
                :min="0"
                :precision="2"
                placeholder="Дүнг оруулна уу"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Дансны дугаар" prop="account_number">
              <el-input v-model="formData.account_number" placeholder="Дансны дугаар оруулна уу" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="!isTransferType" label="Тайлбар" prop="description">
          <el-input type="textarea" v-model="formData.description" placeholder="Тайлбар оруулна уу" :rows="3" />
        </el-form-item>
        <el-form-item v-if="isTransferType" label="Тайлбар" prop="description">
          <el-input type="textarea" v-model="formData.description" placeholder="Тайлбар оруулна уу" :rows="3" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">Хадгалах</el-button>
          <el-button @click="handleClose">Цуцлах</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import services from '@/helpers/services'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateCostDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedCost: {
      type: Object,
      default: () => ({})
    },
    costType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      dialogVisible: this.visible,
      branches: [],
      isTransferType: false,
      formData: {
        date: '',
        created_by_user_id: null,
        description: '',
        amount: null,
        account_number: '',
        branch_id: null,
        transfer_from_branch_id: null,
        transfer_to_branch_id: null
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    rules () {
      return {
        date: [{
          required: true,
          message: 'Огноо сонгоно уу',
          trigger: 'change'
        }],
        amount: [{
          required: true,
          message: 'Дүнг оруулна уу',
          trigger: 'blur'
        }],
        transfer_from_branch_id: [{
          required: this.isTransferType,
          message: 'Шилжүүлэх салбар сонгоно уу',
          trigger: 'change'
        }],
        transfer_to_branch_id: [{
          required: this.isTransferType,
          message: 'Хүлээн авах салбар сонгоно уу',
          trigger: 'change'
        }]
      }
    }
  },
  watch: {
    visible (newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.checkCostType()
        this.loadBranches()
      }
    },
    dialogVisible (newVal) {
      if (!newVal) {
        try {
          this.$emit('close')
        } catch (error) {
          console.error('Error emitting close event:', error)
        }
      }
    },
    selectedCost: {
      immediate: true,
      handler (newValue) {
        try {
          if (newValue && newValue.id) {
            this.formData = {
              ...newValue,
              date: newValue.date ? newValue.date.split('T')[0] : '',
              transfer_from_branch_id: newValue.transfer_from_branch_id || null,
              transfer_to_branch_id: newValue.transfer_to_branch_id || null
            }
          } else {
            // Шинээр нэмэх үед branch_id-г user-с авна
            const userBranchId = (this.user && this.user.branch_id) ? this.user.branch_id : null
            this.formData = {
              date: '',
              created_by_user_id: (this.user && this.user.id) ? this.user.id : null,
              description: '',
              amount: null,
              account_number: '',
              branch_id: userBranchId,
              transfer_from_branch_id: null,
              transfer_to_branch_id: null
            }
          }
        } catch (error) {
          console.error('Error handling selectedCost:', error)
        }
      }
    }
  },
  created () {
    this.loadBranches()
  },
  methods: {
    handleClose () {
      this.formData = {
        date: '',
        created_by_user_id: null,
        description: '',
        amount: null,
        account_number: '',
        branch_id: null,
        transfer_from_branch_id: null,
        transfer_to_branch_id: null
      }
      this.dialogVisible = false
      this.$emit('close')
    },
    checkCostType () {
      this.isTransferType = this.costType === 'transfer'
    },
    async submitForm () {
      if (!this.$refs.formRef) {
        console.error('Form ref is not available')
        return
      }
      try {
        this.$refs.formRef.validate(async (valid) => {
          if (valid) {
            try {
              let typeId = null
              // Cost type-аас type_id олох
              try {
                if (this.costType === 'porter') {
                  const costTypesResponse = await services.getCostTypes()
                  const costTypes = (costTypesResponse && costTypesResponse.data) ? costTypesResponse.data : (Array.isArray(costTypesResponse) ? costTypesResponse : [])
                  const porterType = costTypes.find(ct => ct && ct.name && ct.name.toLowerCase().includes('портер'))
                  if (porterType) {
                    typeId = porterType.id
                  }
                } else if (this.costType === 'flow') {
                  const costTypesResponse = await services.getCostTypes()
                  const costTypes = (costTypesResponse && costTypesResponse.data) ? costTypesResponse.data : (Array.isArray(costTypesResponse) ? costTypesResponse : [])
                  const flowType = costTypes.find(ct => ct && ct.name && (ct.name.toLowerCase().includes('урсгал') || ct.name.toLowerCase().includes('урсгал зардал')))
                  if (flowType) {
                    typeId = flowType.id
                  }
                } else if (this.costType === 'transfer') {
                  typeId = null
                }
              } catch (costTypeError) {
                console.error('Error loading cost types:', costTypeError)
                // Continue without typeId if cost types can't be loaded
              }

              // Payload үүсгэх
              const payload = {
                type_id: typeId,
                date: this.formData.date || null,
                created_by_user_id: (this.user && this.user.id) ? this.user.id : null,
                description: this.formData.description || null,
                amount: this.formData.amount || null,
                account_number: this.formData.account_number || null,
                branch_id: this.formData.branch_id || null,
                transfer_from_branch_id: this.formData.transfer_from_branch_id || null,
                transfer_to_branch_id: this.formData.transfer_to_branch_id || null
              }

              // Edit үед id нэмэх
              if (this.formData.id) {
                payload.id = this.formData.id
              }

              let response
              if (this.formData.id) {
                response = await services.updateCost(payload)
              } else {
                response = await services.createCost(payload)
              }
              if (response) {
                this.$message.success(this.formData.id ? 'Амжилттай шинэчиллээ!' : 'Амжилттай үүсгэлээ!')
                this.handleClose()
                this.$emit('refresh')
              }
            } catch (error) {
              const errorMessage = (error && error.message) ? error.message : (error ? String(error) : 'Алдаа гарлаа')
              console.error('API Request Error:', errorMessage)
              this.$message.error(errorMessage)
            }
          } else {
            return false
          }
        })
      } catch (validationError) {
        const errorMessage = (validationError && validationError.message) ? validationError.message : (validationError ? String(validationError) : 'Form validation error')
        console.error('Form validation error:', errorMessage)
        this.$message.error('Форм шалгахад алдаа гарлаа')
      }
    },
    async loadBranches () {
      try {
        const response = await services.getBranchesWeb()
        if (response && response.type === 'success') {
          this.branches = response.data || []
        } else if (response && response.data) {
          this.branches = response.data || []
        }
      } catch (error) {
        console.error('Error loading branches:', error)
        this.branches = []
      }
    }
  }
}
</script>

<style scoped>
.el-form {
  max-width: 100%;
}
</style>
